import { AdminBusinessCredits } from 'screens/admin/AdminBusinessCredits';
import { Outlet, createBrowserRouter } from 'react-router-dom';

import { PrivateRoutes } from './PrivateRoutes';
import { CreateCampaignScreen } from 'screens/CreateCampaignScreen';
import { HomeScreen } from 'screens/HomeScreen';
import { LoginScreen } from 'screens/LoginScreen';
import { PurchaseCreditsScreen } from 'screens/PurchaseCreditsScreen';
import { USER_ROLE } from 'constants/enums/user-roles';
import { RoleRouteWrapper } from './RoleRouteWrapper';
import { AdminManageUsers } from 'screens/admin/AdminManageUsers';
import { AdminManageAttributes } from 'screens/admin/AdminManageAttritbutes';
import { AdminApiConfiguration } from 'screens/admin/AdminApiConfiguration';
import { AdminManageTestUsers } from 'screens/admin/AdminManageTestUsers';
import { AdminManageStores } from 'screens/admin/AdminManageStores';
import { AdminAddUser } from 'screens/admin/AdminAddUser';
import { AdminEditUser } from 'screens/admin/AdminEditUser';
import { ResultPage } from 'components/ResultPage';
import { CampaignResultsScreen } from 'screens/CampaignResultsScreen';
import { AdminAddTestUser } from 'screens/admin/AdminAddTestUser';
import { ScheduledCampaigns } from 'screens/ScheduledCampaigns';
import { CampaignAnalyticsScreen } from 'screens/CampaignAnalyticsScreen';
import { ForgotPasswordScreen } from 'screens/ForgotPasswordScreen';
import { ResetPasswordScreen } from 'screens/ResetPasswordScreen';
import { LoadingScreen } from 'screens/LoadingScreen';
import { SuccessScreen } from 'components/SuccessScreen';
import { PURCHASE_CREDITS_SCREEN } from 'constants/enums/purchase-credits-screen';
import { HelpScreen } from 'screens/HelpScreen';
import { AdminGlobalConfiguration } from 'screens/admin/AdminGlobalConfiguration';
import { AdminManageTestUsersPush } from 'screens/admin/AdminManageTestUsersPush';
import { AdminAddTestUserPush } from 'screens/admin/AdminAddTestUserPush';

export const router = createBrowserRouter(
  [
    {
      id: 'login',
      path: '/',
      element: <LoginScreen />,
      errorElement: <ResultPage />,
    },
    {
      id: 'azure-login',
      path: '/login/azure',
      element: <LoadingScreen />,
      errorElement: <ResultPage />,
    },
    {
      id: 'forgot-password',
      path: '/forgot-password',
      element: <ForgotPasswordScreen />,
      errorElement: <ResultPage />,
    },
    {
      id: 'password-reset',
      path: '/password-reset',
      element: <ResetPasswordScreen title='Reset password' />,
      errorElement: <ResultPage />,
    },
    {
      id: 'invite-user',
      path: '/invite-user',
      element: <ResetPasswordScreen title='Setup password' />,
      errorElement: <ResultPage />,
    },
    {
      id: 'PrivateRoutes',
      element: <PrivateRoutes />,
      errorElement: <ResultPage />,
      children: [
        {
          id: 'home',
          path: 'home',
          Component: HomeScreen,
        },
        {
          id: 'help',
          path: 'help',
          element: <HelpScreen />,
          errorElement: <ResultPage />,
        },
        {
          id: 'create-campaign',
          path: 'create-campaign',
          Component: CreateCampaignScreen,
        },
        {
          id: 'campaign-analytics',
          path: 'campaign-analytics',
          Component: CampaignAnalyticsScreen,
        },
        {
          id: 'campaign-analytics-id',
          path: 'campaign-analytics/:id',
          Component: CampaignResultsScreen,
        },
        {
          id: 'scheduled-campaigns',
          path: 'scheduled-campaigns',
          Component: ScheduledCampaigns,
        },
        {
          element: (
            <RoleRouteWrapper roles={[USER_ROLE.franchiseOwner]}>
              <Outlet />
            </RoleRouteWrapper>
          ),
          children: [
            {
              id: 'purchase-credits',
              path: 'purchase-credits',
              Component: PurchaseCreditsScreen,
            },
            {
              id: 'purchase-credits-success',
              path: 'purchase-credits-success',
              element: (
                <SuccessScreen
                  pageTitle={PURCHASE_CREDITS_SCREEN.PURCHASE_CREDITS}
                  successTitle={PURCHASE_CREDITS_SCREEN.CONFIRMED_PURCHASE}
                  successSubtitle={
                    PURCHASE_CREDITS_SCREEN.CREDIT_UPDATE_MESSAGE
                  }
                  buttonLabel={PURCHASE_CREDITS_SCREEN.GO_BACK_TO_DASHBOARD}
                />
              ),
            },
            {
              id: 'purchase-credits-failure',
              path: 'purchase-credits-failure',
              element: <ResultPage />,
            },
          ],
        },
        {
          element: (
            <RoleRouteWrapper roles={[USER_ROLE.admin, USER_ROLE.developer]}>
              <Outlet />
            </RoleRouteWrapper>
          ),
          children: [
            {
              path: '/admin',
              element: <AdminManageUsers />,
            },
            {
              path: '/admin/business-credits',
              element: <AdminBusinessCredits />,
            },
            {
              path: '/admin/manage/users',
              element: <AdminManageUsers />,
            },
            {
              path: '/admin/manage/users/add',
              element: <AdminAddUser />,
            },
            {
              path: '/admin/manage/users/:id',
              element: <AdminEditUser />,
            },
            {
              path: '/admin/manage/test-users',
              element: <AdminManageTestUsers />,
            },
            {
              path: '/admin/manage/test-users/add',
              element: <AdminAddTestUser />,
            },
            {
              path: '/admin/manage/test-users-push',
              element: <AdminManageTestUsersPush />,
            },
            {
              path: '/admin/manage/test-users-push/add',
              element: <AdminAddTestUserPush />,
            },
            {
              path: '/admin/manage/stores',
              element: <AdminManageStores />,
            },
            {
              path: '/admin/manage/attributes',
              element: <AdminManageAttributes />,
            },
            {
              path: '/admin/api-configuration',
              element: (
                <RoleRouteWrapper roles={[USER_ROLE.developer]}>
                  <AdminApiConfiguration />
                </RoleRouteWrapper>
              ),
            },
            {
              path: '/admin/global-configuration',
              element: (
                <RoleRouteWrapper roles={[USER_ROLE.developer]}>
                  <AdminGlobalConfiguration />
                </RoleRouteWrapper>
              ),
            },
          ],
        },
      ],
    },
  ],
  { basename: '/' }
);
